<div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center ">Perfil</h1></div>
    </div>

    <div class="">
        <div class="imgPerfil" [style.background-image]="preview_img_avatar ? 'url(' + preview_img_avatar + ')' : 'url(./assets/img/profesional-init.png)'"> </div>
        <div class="chkPerfil fade-in"><i class="bi bi-check-circle-fill" style="color: #205EA5;float:right;"></i></div>
    </div>
    <!-- Sections -->
    <div class="row-cols-12 m-2 mt-0">
        <div class="row-cols-12 mt-0">
            <div class="text-p p-3 pt-0 pb-0" style="font-weight: bold; font-size: 1.3em;">
                <hr style="width:20%;height: 5px;color: #CDCFD0;border-radius: 10px;margin: 0 auto;">
            </div>    
        </div>
        <div class="row-cols-12 mt-0">
            <div class="text-p p-3 pb-1 nameUser">
                {{nombre}}
            </div>
        </div>
        
        <hr class="divisor mt-0 mb-1">

        <div class="row-cols-12 mt-0">
            <div class="row p-3 pb-0">
                <div class="col-4 text-start fieldName">
                    {{tipo_documento}}
                </div>
                <div class="col-8 col-lg-10 fw-bold fieldInfo text-end text-truncate">
                    {{nro_documento}}
                </div>
            </div>
            <div class="row p-3 pb-0">
                <div class="col-4 text-start fieldName">
                    MAIL
                </div>
                <div class="col-8 col-lg-10 fw-bold fieldInfo text-end text-truncate">
                    {{email}}
                </div>
            </div>
            <div class="row p-3 pb-0">
                <div class="col-4 text-start fieldName">
                    Teléfono
                </div>
                <div class="col-8 col-lg-10 fw-bold fieldInfo text-end text-truncate">
                    {{telefono}}
                </div>
            </div>
            <div class="row p-3 pb-0">
                <div class="col-4 text-start fieldName">
                    Prepaga
                </div>
                <div class="col-8 col-lg-10 fw-bold fieldInfo text-end text-truncate">
                    {{prepaga}}
                </div>
            </div>
            @if(plan_prepaga && plan_prepaga.length > 0){
                <div class="row p-3 pb-0">
                    <div class="col-4 text-start fieldName">
                        Plan
                    </div>
                    <div class="col-8 col-lg-10 fw-bold fieldInfo text-end text-truncate">
                        {{plan_prepaga}}
                    </div>
                </div>
            }
        </div>
        <!--<hr class="divisor mt-3 mb-1">-->
    </div>
    <!--<div class="d-grid mt-4 mb-2">
        <button type="submit" class="btn btn-primary btn-lg mt-0" (click)="whatsapp()">Mensaje al celular</button>
    </div>-->
</div>